module.exports = __webpack_public_path__ + "img/pic01.cde18478.jpg";